// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_2vkrZ){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3bP2z .dualColumn_3X16Q{display:flex;align-content:space-between}.nsAddressForm_3bP2z .dualColumn_3X16Q .firstCol_3YMKJ{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_2vkrZ",
	"nsAddressForm": "nsAddressForm_3bP2z",
	"dualColumn": "dualColumn_3X16Q",
	"firstCol": "firstCol_3YMKJ"
};
module.exports = exports;
